import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Button, Image } from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { SetPageTittle } from "../services/utils";
const Header = () => {
    let navigate = useNavigate()


    return (
        <Navbar bg="light" expand="xl" sticky="top" className="main_hdr">
            <Container className="custm_container">
                <Navbar.Brand onClick={()=>{navigate("/")}}>
                    <Image src={Logo} fluid className="logo_img" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link onClick={()=>{navigate("/")}}>Home</Nav.Link>

                        <NavDropdown title="School" id="basic-nav-dropdown">
                            <NavDropdown.Item onClick={() => { SetPageTittle({tittle: "School"});navigate("/signin") }}>
                                Log In
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => { SetPageTittle({tittle: "School"});navigate("/signup") }} >
                                Register
                            </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown  title="Student" id="basic-nav-dropdown">
                            <NavDropdown.Item onClick={() => { SetPageTittle({tittle: "Student"});navigate("/signin")}}>
                                Log In
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => { SetPageTittle({tittle: "Student"});navigate("/signup")}}>
                                Register
                            </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown  title="Hospital" id="basic-nav-dropdown">
                            <NavDropdown.Item onClick={() => { SetPageTittle({tittle: "Hospital"});navigate("/signin")}}>
                                Log In
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => { SetPageTittle({tittle: "Hospital"});navigate("/signup")}}>
                                Register
                            </NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link onClick={()=>{navigate("/faq")}}>FAQs</Nav.Link>
                        <Nav.Link onClick={()=>{navigate("/about-us")}}>About Us</Nav.Link>
                        <Nav.Link onClick={()=>{navigate("/contact-us")}}>Contact Us</Nav.Link>
                        {/* <NavDropdown title="Contact" id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">
                                Sales
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">
                                Support
                            </NavDropdown.Item>
                        </NavDropdown> */}
                    </Nav>
                    <div className="login_btns ms-3">
                        <Button className="btn_theme ms-2" onClick={()=>{navigate("/schedule_call")}} variant="">
                            Schedule Demo
                        </Button>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
